import { render, staticRenderFns } from "./BrokerMiniChat.vue?vue&type=template&id=75dd6340&scoped=true&"
import script from "./BrokerMiniChat.vue?vue&type=script&lang=js&"
export * from "./BrokerMiniChat.vue?vue&type=script&lang=js&"
import style0 from "./BrokerMiniChat.vue?vue&type=style&index=0&id=75dd6340&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dd6340",
  null
  
)

export default component.exports